// client/src/showingRoutes.js — the showing scheduler's screens (feature #2, 19 Oct 2026).
//   Public:     /showing-feedback/:token   (the feedback link sent after a showing)
//   Dashboard:  /dashboard/showings        (requests, availability, listing + office settings)
// The booking picker itself sits on the property page (components/public/ShowingBooking).
import React from 'react';
import { Route } from 'react-router-dom';
import ShowingsPage from './pages/secure/ShowingsPage';
import ShowingFeedbackPage from './pages/ShowingFeedbackPage';

/** Under the public layout ("/"). */
export const showingPublicRoutes = () => [
    <Route key="showing-feedback" path="showing-feedback/:token" element={<ShowingFeedbackPage />} />,
];

/** Under /dashboard (staff login). */
export const showingDashboardRoutes = () => [
    <Route key="showings" path="showings" element={<ShowingsPage />} />,
];
